<template>
  <div>Forbidden</div>
</template>

<script>
import store from "@/store";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "isSalerAccount",
      "isStoreManagerAccount",
      "isAreaManagerAccount",
    ]),
  },
  async mounted() {
    await store.accountReady();
    if (this.isSalerAccount) {
      this.$router.replace({ name: "SADashboard" });
    } else if (this.isStoreManagerAccount) {
      this.$router.replace({ name: "StoreManagerDashboard" });
    } else if (this.isAreaManagerAccount) {
      this.$router.replace({ name: "AreaManagerDashboard" });
    }
  },
};
</script>
